module.exports = __webpack_public_path__ + "static/woman-bl-876e8988fadb2697750800c85c1d06a2.jpg";